<template>
  <li class="roadmap" role="none">
    <div
      class="roadmap-group"
      role="group"
      aria-labelledby="software-factory-roadmap-label"
    >
      <div id="software-factory-roadmap-label" class="roadmap-label">
        Coming soon
      </div>
      <div class="roadmap-items">
        <component
          :is="item.to ? 'router-link' : 'span'"
          v-for="item in items"
          :key="item.label"
          class="roadmap-item"
          :class="{ 'roadmap-item-link': item.to }"
          v-bind="item.to ? { to: item.to } : {}"
        >
          {{ item.label }}
        </component>
      </div>
    </div>
  </li>
</template>

<script>
const ROADMAP_ITEMS = [{ label: "Factory" }, { label: "Skills" }];

export default {
  name: "SoftwareFactoryRoadmap",

  computed: {
    items() {
      return ROADMAP_ITEMS;
    },
  },
};
</script>

<style scoped>
/* Match Ant Design Vue's dark-menu token palette used by the legacy sidebar. */
.roadmap {
  padding: 2px 12px 10px;
}

.roadmap-group {
  width: fit-content;
  margin-inline: auto;
}

.roadmap-label {
  color: rgba(255, 255, 255, 0.65);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  line-height: 18px;
  text-transform: uppercase;
}

.roadmap-items {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
}

.roadmap-item {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 2px;
  color: rgba(255, 255, 255, 0.65);
  cursor: default;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  padding: 0 8px;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;
}

.roadmap-item-link {
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
}

.roadmap-item-link:hover {
  color: rgba(255, 255, 255, 0.85);
  opacity: 0.85;
}
</style>
